import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'node_modules/@commenda/kakashi';
import { CreateWorkflowTemplateLinkForm } from '../forms/CreateWorkflowTemplateLinkForm';

type TCreateWorkflowTemplateLinksModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  lockedWorkflowTemplateId?: string;
};

export const CreateWorkflowTemplateLinksModal = ({
  isOpen,
  onClose,
  onSuccess,
  lockedWorkflowTemplateId,
}: TCreateWorkflowTemplateLinksModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create workflow template links</DialogTitle>
        </DialogHeader>
        <CreateWorkflowTemplateLinkForm
          lockedWorkflowTemplateId={lockedWorkflowTemplateId}
          onSuccess={onSuccess}
          onCancel={onClose}
          formContentClassName="p-3xl"
          formFooterClassName="p-3xl"
        />
      </DialogContent>
    </Dialog>
  );
};
